export const ITEMS_CONTAINER_X = -100;

export const MAX_TIME_TO_SWIPE = 300;

export const MIN_PERCENT_TO_SLIDE = 50;

export const MIN_PERCENT_TO_SWIPE = 10;
